<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="key-sequence-register.title"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div class="mb-3 row">
		<div class="col">
			<span jhiTranslate="key-sequence-register.description"></span>
		</div>
	</div>
	<div class="mb-3 row">
		<label for="prefix" class="col-sm-3 col-form-label"><span jhiTranslate="key-sequence-register.enter.prefix"></span></label>
		<div class="col-sm-4">
			<input type="text" class="form-control" autocomplete="off" name="prefix" id="prefix" [maxLength]="20" [(ngModel)]="prefixValue"/>
		</div>
		<div class="col-sm-3">
			<button type="button" class="btn btn-primary" (click)="add(prefixValue)">
				<span class="fa fa-plus"></span>&nbsp;
				<span jhiTranslate="key-sequence-register.add.prefix"></span></button>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<table class="table table-striped table-curved" *ngIf="prefixes.length else nodata">
				<thead>
				<tr>
					<th><span jhiTranslate="key-sequence-register.prefix"></span></th>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr *ngFor="let prefix of prefixes; let i = index;">
					<td><span>{{prefix}}</span></td>
					<td class="float-end">
						<button type="button" class="btn btn-secondary" (click)="remove(i)">
							<span class="fa fa-minus"></span>&nbsp;
							<span jhiTranslate="key-sequence-register.remove"></span></button>
					</td>
				</tr>
				<tr>
				</tr>
				</tbody>
			</table>
			<ng-template #nodata>
				<table class="table table-striped table-curved">
					<thead>
					<tr>
						<th></th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td jhiTranslate="key-sequence-register.no.prefix.added"></td>
					</tr>
					</tbody>
				</table>
			</ng-template>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()">
		<span class="fa fa-ban"></span>&nbsp;
		<span jhiTranslate="cancel"></span>
	</button>
	<button (click)="delete()" class="btn btn-primary" [disabled]="prefixes.length <= 0">
		<span class="fa fa-trash"></span>&nbsp;
		<span jhiTranslate="key-sequence-register.delete"></span>
	</button>
</div>
